import { CallOutError } from "components/CallOutError/CallOutError";
import { useWorkflowEditorContext } from "components/WorkflowEditor/WorkflowEditorProvider/WorkflowEditorProvider";
import { StepParamMapping } from "pages/gdt/modals/ModalCreateColumn/steps/StepParamMapping";
import { ToolSpecV3 } from "types/json-schemas/ToolSpecV3";

export const WorkflowEditorPageMapSources = () => {
  const { params, workflowParamToNameMap } = useWorkflowEditorContext((s) => {
    const workflowParamToNameMap: Record<string, string> = {};
    const tableInfoOverrides = s.tableInfoOverrides;
    const params = s.workflowGraph?.inputs
      .filter((input) => !input.intermediate)
      .map<ToolSpecV3["params"][number]>((input) => {
        const paramKey = input.key + "-" + input.id;

        workflowParamToNameMap[paramKey] =
          tableInfoOverrides[input.table_id].name;

        return {
          type: {
            param_type: "ToolPathParam",
            multiple: true,
          },
          description: input.key,
          key: paramKey,
          help: input.name,
          name: input.name,
          /** ??? hidden was in tool spec what is this for*/
          hidden: false,
          required: false,
        };
      });

    return { params, workflowParamToNameMap };
  });

  const excludeTables = useWorkflowEditorContext((s) =>
    s.tableInfo.map((t) => t.id),
  );

  const sourceMap = useWorkflowEditorContext((s) => s.sourceMap);
  const setParamMap = useWorkflowEditorContext((s) => s.setParamMap);
  const setSourceTableIds = useWorkflowEditorContext(
    (s) => s.setSourceTableIds,
  );

  if (params === undefined) {
    return <CallOutError />;
  }

  return (
    <StepParamMapping
      dataTableId={undefined}
      setSourceTableIds={setSourceTableIds}
      excludeTables={excludeTables}
      sourceTableIds={sourceMap.sourceTableIds}
      toolSpec={{ params }}
      paramMap={{ value: sourceMap.map, isDirty: true }}
      setParamMap={(paramMap) => {
        setParamMap(() => paramMap);
      }}
      paramKeyToWorkflowStepLabelMap={workflowParamToNameMap}
    />
  );
};
